<template>
  <div v-if="activeLinks.length">
    <hr>
    <p
      v-for="(link, index) in activeLinks"
      :key="index"
    >
      <router-link
        :class="link.class"
        :to="link.routerInfo"
      >
        {{ link.display }}
      </router-link>
    </p>
  </div>
</template>

<script>
import CompanyLoginMixin from '@/Client/Mixin/CompanyLogin';

export default {
  name: 'LoginLinks',
  mixins: [CompanyLoginMixin],
  computed: {
    activeLinks() {
      const links = [
        {
          display: 'Forgotten your password?',
          routerInfo: {name: 'forgotPassword'},
          active: true,
          class: this.companyCssClass,
        },
      ];

      if (
        this.hasCompanyLogin &&
        Object.hasOwn(this.companyLogin, 'requestAccountEnabled') &&
        this.companyLogin.requestAccountEnabled
      ) {
        links.unshift({
          display: 'Request Access',
          routerInfo: {name: 'requestAccess'},
          active: true,
          class: this.companyCssClass,
        });
      }

      return links.filter((link) => link.active);
    },
  },
};
</script>

<style scoped>

</style>
